import { Component, Input, OnInit, SimpleChange, SimpleChanges, OnChanges, ChangeDetectorRef } from '@angular/core';
import { MapElement } from '../../../../shared/map/map-element.model';
import { GeometryObject } from 'geojson';

@Component({
  selector: 'qm-train-hover',
  templateUrl: './train-hover.component.html',
  styleUrls: ['./train-hover.component.scss']
})
export class TrainHoverComponent implements OnInit, OnChanges {

  @Input()
  public selectedFeature: MapElement<GeometryObject>;

  public deltaColor: string;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.selectedFeature.isFirstChange()
        || changes.selectedFeature.currentValue.properties.markerContainerClass
            !== changes.selectedFeature.previousValue.properties.markerContainerClass) {
      this.deltaColor = this.getColor();
      this.cdr.detectChanges();
    }
  }

  public getColor() {
    try {
      if (this.selectedFeature.properties.markerContainerClass.includes('success')) {
        return window.getComputedStyle(document.body).getPropertyValue('--color-success-base');
      } else if (this.selectedFeature.properties.markerContainerClass.includes('warning')) {
        return window.getComputedStyle(document.body).getPropertyValue('--color-warning-base');
      } else if (this.selectedFeature.properties.markerContainerClass.includes('danger')) {
        return window.getComputedStyle(document.body).getPropertyValue('--color-danger-base');
      }
    } catch (e) {
    }
    return window.getComputedStyle(document.body).getPropertyValue('--color-info-base');
  }

}
